<template>
  <DotLottieVue ref="Service1" class="size-[200px] lg:size-[15vw]" autoplay :src="props.src" />
</template>

<script setup>
const props = defineProps({
  src: {
    type: String,
    default: "",
  },
})

const Service1 = ref();

const initiateInterval = () => {
  setInterval(() => {
    if (Service1.value && import.meta.client) {
      const lottieInstance = Service1.value.getDotLottieInstance()
      lottieInstance.play()
    }
  }, 9100)
}

onMounted(() => {
  nextTick(() => {
    initiateInterval()
  })
})
</script>
